export default __webpack_public_path__ + "static/N0174-63e6191ef9b3d40c4f18e7c86ad25b01.png";